import { render, staticRenderFns } from "./MiniProgramDouMaiKeJiGlassUsers.vue?vue&type=template&id=3784d5e5&scoped=true&"
import script from "./MiniProgramDouMaiKeJiGlassUsers.vue?vue&type=script&lang=js&"
export * from "./MiniProgramDouMaiKeJiGlassUsers.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramDouMaiKeJiGlassUsers.vue?vue&type=style&index=0&id=3784d5e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784d5e5",
  null
  
)

export default component.exports